const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL || "";
const ASSET_API_URL = process.env.REACT_APP_ASSET_API_URL || "";
const COMMON_API_URL = process.env.REACT_APP_COMMON_API_URL || "";
const CIRCLE_API_URL = process.env.REACT_APP_CIRCLE_API_URL || "";
const MEDKIT_API_URL = process.env.REACT_APP_MEDKIT_API_URL || "";
const SEARCH_API_URL = process.env.REACT_APP_SEARCH_API_URL || "";

const IDENTITY_API_URL = `${IDENTITY_URL}/api`;

export {
    IDENTITY_URL,
    ASSET_API_URL,
    COMMON_API_URL,
    CIRCLE_API_URL,
    MEDKIT_API_URL,
    SEARCH_API_URL,
    IDENTITY_API_URL,
};

export const USER_ROLE = {
    REPORTER: "000304", // Báo cáo viên
    SUPERVISOR: "000305", // Người giám sát
    ADMIN: "000306", // Quản lý sự cố
    ADMIN_SERVICE: "00008H", // Quản lý hệ thống (tenant admin)
    HEAD_HOSPITAL: "000308", // Lãnh đạo bệnh viện
    ADMIN_ORGANIZATION: "000309", // Quản lý tổ chức
    HEAD_DEPARTMENT: "00030A", // Quản lý khoa   
}

const Constants = {
    Api: {
        TIMEOUT: 60 * 1000,
    },

    /**
     * Return code from Api
     */
    ApiCode: {
        // Code from server api
        SUCCESS: 200,
        BAD_REQUEST: 400,
        TOKEN_EXPRIED: 401,
        NOT_PERMISSION: 403,
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,

        // Code from local app
        SERVER_ERROR: "SERVER_ERROR",
        INTERNAL_SERVER: "INTERNAL_SERVER",
        UNKNOWN_NETWORK: "UNKNOWN_NETWORK",
        CONNECTION_TIMEOUT: "CONNECTION_TIMEOUT",
        INVALID_USERNAME_OR_PASSWORD: "invalid_username_or_password",
        INVALID_REQUEST: "invalid request",
    },

    /**
     * Setting path for Api
     */
    ApiPath: {
        // Common
        CODENAME: {
            DETAIL: "/Codename/Detail",
            CREATE: "/Codename/Create",
            UPDATE: "/Codename/Update",
            DELETE: "/Codename/Delete",
            GET_PAGED: "/Codename/GetPaged",
            GET_BY_CODE: "/Codename/GetByCode",
            GET_BY_GROUP: "/Codename/GetByGroup",
        },

        // Identity
        PROFILE: {
            USER_INFO: "/Profile/UserInfo",
            UPDATE_AVATAR: "/Profile/ChangeAvatar",
            CHANGE_PASSWORD: "/Profile/ChangePassword",
            UPDATE_PROFILE: "/Profile/UpdateUserProfile",
            USER_AUTHORIZATION: "/Profile/UserAuthorization",
            UPDATE_ORGANIZATION_PROFILE: "/Profile/UpdateOrganizationProfile",
        },

        ROLE: {
            GET_ALL: "/Role/GetAll",
            GET_PAGED: "/Role/GetPaged",
        },

        USER: {
            DETAIL: "/User/Detail",
            GET_PAGED: "/User/GetPaged",
            MERGE_USER: "/User/MergeUser",
        },
        GROUP: {
            GET_ALL: "/Group/GetAll",
            GET_PAGED: "/Group/GetPaged",
        },
        ORGANIZATION: {
            GET_ALL: "/Organization/GetAll",
            GET_PAGED: "/Organization/GetPaged",
        },

        // Medkit
        STATISTICS: {
            GET_STATISTICS: "/Statistics/GetStatistics",
            GET_STATISTICS_BY_YEAR: "/Statistics/GetStatisticsByYear",
            GET_DEPARTMENT_STATISTICS: "/Statistics/GetDepartmentStatistics",
            GET_CLASSIFY_BY_HOSPITAL_STATISTICS: "/Statistics/GetClassifyByHospitalStatistics",
            GET_SYNTHETIC_LIST: "/Statistics/GetSyntheticList",
            GET_FISHBONE: "/Statistics/GetFishboneStatistic",
            GET_FISHBONE_SOLUTION: "/Statistics/GetFishboneSolution",
        },

        REPORT: {
            DETAIL: "/Reports/Detail",
            CREATE: "/Reports/Create",
            UPDATE: "/Reports/Update",
            DELETE: "/Reports/Delete",
            GET_PAGED: "/Reports/GetPaged",
            ASSIGN_REPORT: "/Reports/AssignReport",
            ANALYZE_REPORT: "/Reports/AnalyzeReport",
            UPDATE_STATUS: "/Reports/UpdateReportStatus",
            UPDATE_REPEAT_ISSUE: "/Reports/UpdateRepeatIssue",
            GENERATING_PL: "/Reports/GeneratingPL",
            GENERATING_ASSIGN_REPORTS: "/Reports/GeneratingAssignReports",
            GENERATING_SYNTHESIS_REPORT: "/Reports/GeneratingSynthesisReport",
            GENERATING_UNEXPECTED_INCIDENT_REPORT: "/Reports/GeneratingUnexpectedIncidentReport",
            UPDATE_FISHBONE_ANALYSIS: "/Reports/UpdateFishboneAnalysis",
        },

        PROJECT: {
            DETAIL: "/Projects/Detail",
            CREATE: "/Projects/Create",
            UPDATE: "/Projects/Update",
            DELETE: "/Projects/Delete",
            GET_PAGED: "/Projects/GetPaged",

            CREATE_PROJECT_ORGANIZATION: "/Projects/CreateProjectOrganization",
            DELETE_PROJECT_ORGANIZATION: "/Projects/DeleteProjectOrganizationId",
            GET_PAGED_PROJECT_ORGANIZATION: "/Projects/GetPagedProjectOrganization",

        },

        PROJECT_MEMBER: {
            CREATE: "/ProjectMember/Create",
            DELETE: "/ProjectMember/Delete",
            GET_PAGED: "/ProjectMember/GetPaged",
            GET_BY_CONDITION: "/ProjectMember/GetByCondition",
        },

        USER_PROFILE: {
            DETAIL: "/UserProfile/Detail",
            UPDATE: "/UserProfile/Update",
            INVITE: "/UserProfile/Invite",

        },

        IDENTITY_SYSTEM_SETTING: {
            GET_BY_CONDITION: "/SystemSetting/GetByCondition",
        },

        TAG: {
            CREATE: "/Tag/Create",
            GET_ALL: "/Tag/GetAll",
        },

        ASSETS: {
            UPLOAD_URL: "/Upload",
        }
    },

    /**
     * Styles for app.
     *
     * Color refer
     * @see https://www.rapidtables.com/web/color/index.html
     * @see https://www.w3schools.com/w3css/w3css_colors.asp
     */
    Styles: {
        // =====================================================================
        // Common color
        // =====================================================================
        BLUE_COLOR: "#3b82f6",
        RED_COLOR: "#dc2626",
        GRAY_COLOR: "#808080",
        BLACK_COLOR: "#000000",
        GREEN_COLOR: "#008000",
        WHITE_COLOR: "#FFFFFF",
        PRIMARY_COLOR: "#222224",
        SECONDARY_COLOR: "#7b809a",
        OCEAN_BLUE_COLOR: "#174291",
        LIGHT_BLUE_COLOR: "#12B7BC",
        LIGHT_GRAY_COLOR: "#e5e7eb",
        BRIGHT_OCEAN_BLUE_COLOR: "#1F5DC6",
        PRIMARY_DARK_COLOR: "rgb(13, 142, 147)",

        // New - Analysis - Processing - Processed - Cancelled - Close
        STATUS_COLOR: ["#27AE60", "#FEC600", "#24EBC7", "#00AFF0", "#D3D3D3", "#CED4DA"],

        // =====================================================================
        // Console log style
        // Color refer at: https://www.w3schools.com/w3css/w3css_colors.asp
        // =====================================================================
        CONSOLE_LOG_DONE_ERROR: "border: 2px solid #F44336; color: #000000", // Red
        CONSOLE_LOG_DONE_SUCCESS: "border: 2px solid #4CAF50; color: #000000", // Green
        CONSOLE_LOG_ERROR: "background: #F44336; color: #FFFFFF", // Red
        CONSOLE_LOG_NOTICE: "background: #FF9800; color: #000000; font-size: x-large", // Orange
        CONSOLE_LOG_PREPARE: "border: 2px solid #2196F3; color: #000000", // Blue
        CONSOLE_LOG_START: "background: #2196F3; color: #FFFFFF", // Blue
        CONSOLE_LOG_SUCCESS: "background: #4CAF50; color: #FFFFFF", // Green

        // =====================================================================
        // Common size
        // =====================================================================
        AVATAR_SIZE: "80px",
        DEFAULT_FONTSIZE: "16px",
        DEFAULT_SPACING: "24px",

        // =====================================================================
        // Font size
        // =====================================================================
        FONT_SIZE_SMALL: 13,
        FONT_SIZE_DEFAULT: 15,
        FONT_SIZE_MEDIUM: 18,
        FONT_SIZE_LARGE: 24,
        FONT_SIZE_XLARGE: 27,
        FONT_SIZE_XXLARGE: 32,

        BOX_SHADOW: 3,
        BOX_BORDER_RADIUS: 6,

        COLOR_LAYOUT: {
            BACKGROUND_COLOR_ROOT: "#f0f2f5",
            COLOR_TEXT_ITEM_MENU: "#ffffff",
            COLOR_ITEM_MENU_ACTIVE: "#0f2c60",
            COLOR_ITEM_MENU_ACTIVE_PARENT: "#163978",
        },
    },

    /**
     * Regex Expression
     */
    RegExp: {
        /** https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript */
        EMAIL_ADDRESS: new RegExp(
            `/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@` +
            `((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/`
        ),
        NEW_EMAIL_ADDRESS: new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
        /** https://gist.github.com/HarishChaudhari/0dd5514ce430991a1b1b8fa04e8b72a4 */
        ID_CARD: new RegExp(/^[0-9]{8,12}$/),
        PHONE_NUMBER: new RegExp(/^0([135789]{1})([0-9]{8})$/),
        SPECIAL_CHARACTERS: new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/),
        PASSWORD: new RegExp(`/^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/`),
    },

    /**
     * Storage keys
     */
    StorageKeys: {
        FROM: "FROM",
        LANGUAGE: "LANGUAGE",
        FIRST_URL: "FIRST_URL",
        ORGANIZATION_ID: "ORGANIZATION_ID",
    },

    EventName: {
        TOKEN_EXPIRED: "TOKEN_EXPIRED",
        NOT_PERMISSION: "NOT_PERMISSION",
        NOT_DATA_PERMISSION: "NOT_DATA_PERMISSION",
        NOT_FOUND: "NOT_FOUND",
        PROFILE_NOT_FOUND: "PROFILE_NOT_FOUND",
        LANGUAGE_CHANGE: "LANGUAGE_CHANGE",
        CHOOSE_ORGANIZATION: "CHOOSE_ORGANIZATION",
    },

    /**
     * Cloud Storage config
     */
    CloudStorage: {
        REPORT_PHOTO: "report-photo",
        ANALYSIS_PHOTO: "analysis-photo",
        FISHBONE_DIAGRAM: "fishbone-diagram",
    },

    /**
     * Cookie keys
     */
    CookieNames: {
        LANGUAGE: "lang",
        SESSION_ID: "sessionId",
    },

    /**
     * Row per paged
     */
    PAGE_DEFAULT: 1,
    ROW_PER_PAGE: 20,
    ROW_PER_PAGE_5: 5,
    ROW_PER_PAGE_10: 10,
    ROW_PER_PAGE_20: 20,
    ROW_PER_PAGE_25: 25,
    ROW_PER_PAGE_50: 50,
    ROW_PER_PAGE_100: 100,
    ROW_PER_PAGE_OPTIONS: [20, 50, 100],
    ROW_PER_PAGE_OPTIONS_1: [5, 10, 20],
    ROW_PER_PAGE_OPTIONS_2: [10, 25, 50],

    /**
     * Text max length
     */
    CHAR_MAX_LENGTH: {
        REPORT: 1600,
        REPORT_DETAIL_DESCRIPTION: 3500,
    },

    /**
     * format datetime
     */
    DateFormat: {
        DDMM: "DD/MM",
        MMYYYY: "MM/YYYY",
        DDMMYYYY: "DD/MM/YYYY",
        DDMMYYYY_HHMM: "DD/MM/YYYY HH:mm",
        HHMM_DDMMYYYY: "HH:mm DD/MM/YYYY",
        HHMM: "HH:mm",
        YYYY: "YYYY",
        YYYYMM: "YYYY/MM",
        YYYYMMDD: "YYYY/MM/DD",
        YYYYMMDD_HHMM: "YYYY/MM/DD HH:mm",
        DDDD: "dddd",
    },

    MomentWeekDay: {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
    },

    DefaultLanguage: "vi",
    LanguageContent: {
        VI: "vi",
        EN: "en",
    },

    COCCOC_BRAND_NAME: "CocCoc",

    /**
     * Resources Menu
     */
    ResourceMenu: {
        DASHBOARD: "booking-admin/dashboard",

        AGENT: "booking-adm/agent",
        SUPPLIER: "booking-adm/supplier",
        CUSTOMER: "booking-adm/customer",

        BOOKING: "booking-admin/booking-common",
        BOOKING_HOTEL: "booking-adm/booking-hotel",
        BOOKING_FLIGHT: "booking-adm/booking-flight",

        ORDER: "booking-adm/order",
        CASHBOOK: "booking-adm/cashbook",

        CODENAME: "booking-adm/codename",
        ATTRIBUTE: "booking-adm/attribute",
    },

    /**
     * Resources Code
     */
    ResourceUri: {
        ROLE: "identity/role",
        DASHBOARD: "booking-adm/dashboard",

        CUSTOMER: "sale/partner",
        LOYALTY_CUSTOMER: "sale/loyalty-customer",

        BOOKING_HOTEL: "booking-adm/booking-hotel",
        BOOKING_FLIGHT: "booking-adm/booking-flight",

        ORDER: "booking-adm/order",
        CASHBOOK: "sale/cashbook",

        ATTRIBUTE: "sale/attribute",
        CODENAME: "common/codename",
    },

    // System Setting Code
    TENANT_CODE: "000001",
    SERVICE_CODE: "MEDIS",
    CLIENT_ID: process.env.REACT_APP_DEFAULT_CLIENT_ID as string,

    REDIRECT_URI: "/auth/callback",
    POST_LOGOUT_REDIRECT_URL: "/",

    PERMISSION: {
        [USER_ROLE.ADMIN]: {
            canEdit: true,
            canView: true,
        },
        [USER_ROLE.HEAD_HOSPITAL]: {
            canEdit: false,
            canView: true,
        },
        [USER_ROLE.REPORTER]: {
            canEdit: true,
            canView: true,
        },
        [USER_ROLE.HEAD_DEPARTMENT]: {
            canEdit: false,
            canView: true,
        },
    },

    MenuResourceURI: {
        REPORT: "medis/report",
        MONITORING: "medis/monitoring",
        STATISTIC: "medis/statistic",
        SYNTHETIC: "medis/synthetic",
        DASHBOARD: "medis/dashboard",
        SETTING: "medis/setting",

        PROJECT: "medis/project",
        PROJECT_MEMBER: "medis/project-member",
        PUSH_NOTIFICATION: "medis/push-notification",
        ORGANIZATION: "medis/organization",
        DEPARTMENT: "medis/department",
        USER: "medis/user",
        SYSTEM_SETTING: "medis/system-setting",

    },

    IMPORT_USER_TEMPLATE_LINK: new URL("GetDownloadUrl/727710571352305664", ASSET_API_URL.concat("/")).toString(),
    IMPORT_GROUP_TEMPLATE_LINK: new URL("GetDownloadUrl/727710683214393344", ASSET_API_URL.concat("/")).toString(),
};

export default Constants;
